import React, { useEffect, useState } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import {
  Box,
  Radio,
  RadioGroup,
  useTheme,
  useMediaQuery,
  FormControlLabel,
  FormControl,
  Typography,
  Button,
  Divider,
  Accordion,
  AccordionSummary,
  Dialog,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
// import Atome from '../../assets/icons/atome.jpg'
import Visa from '../../assets/icons/visa.jpg'
import Orange from '../../assets/icons/orange.jpg'
import Express from '../../assets/icons/express.jpg'
import Jcb from '../../assets/icons/jcb.jpg'
import Wechat from '../../assets/icons/wx.jpg'
import { getPaymentInfo, payAtome, pay } from '../../../store/slices/userSlice'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useLocation, useHistory } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useTranslation } from 'react-i18next'
import { useCustomTranslation, useDateFnsLocale } from 'src/hooks'
import InfoWrapper from 'src/mobile/components/InfoWrapper'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

import ENumberFormat from 'src/mobile/themes/components/ENumberFormat'
import { PACKAGE_INFO } from 'src/utils/constant'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
// import CallOutlinedIcon from '@material-ui/icons/CallOutlined'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined'
import EDrawer from 'src/mobile/themes/components/EDrawer'
import PaymentTutorial from 'src/pages/addOrder/PayingPaymentTutorial'
import FixedButtonWrapper from 'src/mobile/components/FixedButtonWrapper'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import translationHK from 'src/assets/locales/zh-HK/translation.json'
import { addPaymentInfo } from 'src/utils/trackingCode'

const useStyles = makeStyles((theme) =>
  createStyles({
    label: {
      marginRight: '0 !important',
      alignItems: 'flex-start',
      flexDirection: 'row-reverse',
    },
    paymentTutorial: {},
    img: {
      height: theme.spacing(5),
      // width: '60px',
      margin: theme.spacing(1, 1),
      [theme.breakpoints.down('xs')]: {
        height: theme.spacing(4),
        margin: theme.spacing(0, 0.5),
      },
    },
    accord: {
      boxShadow: 'none',
    },
    accordion: {
      padding: 0,
      position: 'relative',
      borderTop: '1px solid #E5E7EB',
      borderBottom: '1px solid #E5E7EB',
    },
    accordion3: {
      padding: 0,
      position: 'relative',
      borderBottom: '1px solid #E5E7EB',
    },
    accordion2: {
      padding: 0,
      position: 'relative',
      borderTop: '1px solid #E5E7EB',
    },
    content: {
      display: 'inline-block',
    },
    secondaryHeading: {
      fontSize: 14,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing(5),
    },
    accordionDetails: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: 16,
      justifyContent: 'space-between',
    },
    accordionDetails2: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0,
      justifyContent: 'space-between',
    },
    heading: {
      fontSize: 14,
      fontWeight: 500,
    },
    payment: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: theme.spacing(1),
      '& svg': {
        width: theme.spacing(9),
        height: theme.spacing(4),
        marginRight: theme.spacing(1),
      },
      [theme.breakpoints.down('xs')]: {
        '& svg': {
          width: theme.spacing(9),
          height: theme.spacing(4),
        },
      },
    },
    formControl: {
      display: 'flex',
      alignItems: 'center',
    },
    radioGroup: {
      width: '100%',
    },
    box: {
      position: 'relative',
      marginTop: 10,
      marginBottom: 10,
      // border: '1px solid #E5E5E5',
      borderRadius: '10px',
      padding: theme.spacing(2, 2),
      margin: '0 auto',
      border: '1px solid #F79781',
      [theme.breakpoints.down('xs')]: {
        width: '340px',
      },
    },
    intro: {
      background: '#EAF6FD',
      borderRadius: '8px',
      padding: theme.spacing(1, 1),
    },
    svg: {
      height: 32,
    },
    card: {
      borderRadius: 20,
      border: '1px solid #E5E7EB',
      padding: theme.spacing(2),
    },
    flexLayout: {
      maxWidth: 1300,
      margin: '0 auto',
      padding: theme.spacing(2),
    },
    closeButton: {
      width: theme.spacing(5),
      height: theme.spacing(5),
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: '#111827',
      border: ' 1px solid #111827',
    },
    radio: {
      position: 'absolute',
      top: '18px',
      right: '18px',
      [theme.breakpoints.down('xs')]: {
        top: '10px',
        right: '15px',
      },
    },
    continue: {
      width: 183,
      height: 56,
      fontSize: 18,
      fontWeight: 600,
    },
    button: {
      position: 'absolute',
      top: 16,
      right: 16,
      border: '1px solid #E5E7EB',
      width: 40,
      height:40
    },
  }),
)
const Paying = () => {
  const [value, setValue] = React.useState('1')
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const [expanded, setExpand] = useState(false)

  const { selectedDoctor } = useSelector((state) => state.testCenter)
  const { currency, price, orderNumber, packages } = location?.state || {}
  useEffect(async () => {
    if (!(price && currency && orderNumber)) return history.replace('/profile/order')
    await dispatch(
      getPaymentInfo({
        price: price,
        currency: currency,
        packageId: packages,
      }),
    ).unwrap()
  }, [])
  const [tutorialDialog, setTutorialDialog] = useState(false)

  const { paymentInfo } = useSelector((state) => state.user)
  const { payAtomeStatus, payStatus } = useSelector((state) => state.user)
  const { t } = useTranslation()
  const [tB] = useCustomTranslation()
  const { formatDate } = useDateFnsLocale()

  const handleChange = (event) => {
    setValue(event.target.value)
  }
  const addTrackingCode = () => {
    const title  = PACKAGE_INFO[Number(selectedDoctor?.package)].title
    const titleArr = title.split('.')
    const len = titleArr.length -1;
    let name;
    let num =0
    let obj = translationHK;
    while(num <= len ) {
      name = obj[titleArr[num]];
      obj = obj[titleArr[num]]
      num++
    }
    const ecommerce = {
      currency: selectedDoctor.currency,
      value: selectedDoctor.price,
      payment_type: 'credit card and others',
      items: [
        {
          item_id: PACKAGE_INFO[Number(selectedDoctor?.package)].id,
          item_name: name ,
          index: PACKAGE_INFO[Number(selectedDoctor?.package)].index,
          price: selectedDoctor.price,
          item_category: selectedDoctor.testCenterAddressHk,
          item_category2: selectedDoctor.appointmentDate,
          item_category3: selectedDoctor.appointmentTime,
          item_category4: selectedDoctor.nameHk
        }
      ]
    }
    addPaymentInfo(ecommerce)
  }
  const handleChangeRadio = () => {
    addTrackingCode()
    if (value === '0') {
      onSubmit()
    } else if (value === '1') {
      setTutorialDialog(true)
    }
  }
  const handleReminderDialogCancelSubmit = () => {
    setTutorialDialog(false)
  }
  const onSubmit = () => {
    setTutorialDialog(false)

    try {
      if (value === '0') {
        // TagManager.dataLayer({
        //   dataLayer: {
        //     ecommerce: null,
        //   },
        // })
        // TagManager.dataLayer({
        //   dataLayer: {
        //     event: 'checkout',
        //     ecommerce: {
        //       checkout: {
        //         actionField: { step: 2, option: 'Atome' },
        //         products: [
        //           {
        //             name: selectedDoctor.name || '',
        //             id: `${selectedDoctor.id || ''}`,
        //             price: `${selectedDoctor.price || ''}`,
        //             brand: selectedDoctor.testCenterName || '',
        //             category: selectedDoctor[tB('honoraryTitle')] || '',
        //             variant: selectedDoctor.appointmentTime || '',
        //             dimension1: selectedDoctor.appointmentDate || '',
        //             quantity: 1,
        //           },
        //         ],
        //       },
        //     },
        //   },
        // })
        dispatch(payAtome({ orderNumber: orderNumber, packageId: packages }))
      } else {
        // TagManager.dataLayer({
        //   dataLayer: {
        //     ecommerce: null,
        //   },
        // })
        // TagManager.dataLayer({
        //   dataLayer: {
        //     event: 'checkout',
        //     checkout_option: {
        //       checkout: {
        //         actionField: { step: 2 },
        //         products: [
        //           {
        //             name: selectedDoctor.name || '',
        //             id: `${selectedDoctor.id || ''}`,
        //             price: `${selectedDoctor.price || ''}`,
        //             brand: selectedDoctor.testCenterName || '',
        //             category: selectedDoctor[tB('honoraryTitle')] || '',
        //             variant: selectedDoctor.appointmentTime || '',
        //             dimension1: selectedDoctor.appointmentDate || '',
        //             quantity: 1,
        //           },
        //         ],
        //       },
        //     },
        //   },
        // })
        dispatch(pay({ orderNumber: orderNumber }))
      }
    } catch (error) {
      toast.warning(t('toast.pay_fail'), {
        onClose: () => {
          history.replace('/profile/order')
        },
      })
    }
  }

  const productAbstract = () => {
    return (
      <Box className={isMobile ? {} : classes.card}>
        <Accordion className={classes.accord} expanded={expanded} onChange={() => setExpand(!expanded)}>
          <AccordionSummary
            aria-controls="panel1a-content"
            id="panel1a-header"
            classes={{
              root: !isMobile ? classes.accordion3 : expanded ? classes.accordion2 : classes.accordion,
              content: classes.content,
            }}
          >
            <Box display="flex" justifyContent="space-between">
              <Box className={classes.column} flexShrink="0" display="flex" alignItems="center">
                <Typography className={classes.heading}>
                  {expanded ? t('common.order_datail_hide') : t('common.order_datail')}
                </Typography>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Box>
              <Box>
                <Typography className={classes.secondaryHeading}>
                  <ENumberFormat
                    value={Number(selectedDoctor?.price)}
                    currency={paymentInfo?.currency}
                    color="#111827"
                  />
                </Typography>
              </Box>
            </Box>
          </AccordionSummary>{' '}
          <Box>
            <Box fontSize={18} fontWeight={700}>
              {t(PACKAGE_INFO[Number(selectedDoctor?.package)].title)}
            </Box>
            <Box mt={1}>
              <ENumberFormat
                fontSize={18}
                color="secondary.main"
                value={Number(selectedDoctor?.price)}
                currency={paymentInfo?.currency}
              />
            </Box>
          </Box>
          <Box display="flex" alignItems="center" my={2}>
            <LocationOnOutlinedIcon variant="outline" style={{ fontSize: 24, marginRight: 4 }} />
            <Box component="span" fontSize={16} fontWeight={700}>
              {selectedDoctor?.[tB('testCenterName')]}
            </Box>
          </Box>{' '}
          <Box fontSize={14} ml={2.5} mb={2} color="#4B5563">
            {selectedDoctor?.[tB('testCenterAddress')]}
          </Box>
          <Divider />
          {/* <Box display="flex" alignItems="center" my={1}>
                <CallOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
                <Box component="span" fontSize={14}>
                  {selectedDoctor?.phone}
                </Box>
              </Box>
              <Divider /> */}
          <Box display="flex" alignItems="center" my={2}>
            <DateRangeOutlinedIcon
              variant="outline"
              style={{ fontSize: isMobile ? 24 : 18, marginRight: 4 }}
            />
            <Box component="span" fontSize={isMobile ? 16 : 16} mr={4}>
              {formatDate(new Date(selectedDoctor?.appointmentDate))}
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box component="span" fontSize={14} mx={4} display="flex" alignItems="center">
              <AccessTimeIcon variant="outline" style={{ fontSize: isMobile ? 24 : 18, marginRight: 4 }} />
              <Box fontSize={isMobile ? 16 : 16}> {selectedDoctor?.appointmentTime}</Box>
            </Box>
          </Box>
          <Divider />
          <Box display="flex" alignItems="center" my={2}>
            <PermContactCalendarOutlinedIcon
              variant="outline"
              style={{ fontSize: isMobile ? 24 : 18, marginRight: 4 }}
            />
            <Box component="span" fontSize={isMobile ? 16 : 16} fontWeight={700}>
              {selectedDoctor?.[tB('name')] || ''}
            </Box>
          </Box>
          <Divider />
        </Accordion>
        <Box className={expanded ? classes.accordionDetails2 : classes.accordionDetails}>
          <Box className={classes.column} color="#4B5563">
            <Typography className={classes.heading}>{t('common.add_summary')}</Typography>
          </Box>
          <Box>
            <Typography className={classes.secondaryHeading}>
              <ENumberFormat
                value={Number(selectedDoctor?.price)}
                currency={paymentInfo?.currency}
                color="#111827"
              />
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box px={isMobile ? 0 : 4} pb={8}>
      <InfoWrapper title={t('payMents.payMethods.0')}>{isMobile && productAbstract()}</InfoWrapper>
      <Box
        className={isMobile ? {} : classes.flexLayout}
        display={isMobile ? 'block' : 'flex'}
        justifyContent="center"
        mt={2}
      >
        <Box className={isMobile ? {} : classes.card} width={isMobile ? '100%' : '65%'}>
          <Box mt={isMobile ? 1 : 3}>
            <FormControl className={classes.formControl}>
              <RadioGroup value={value} onChange={handleChange} className={classes.radioGroup}>
                <InfoWrapper className={classes.box} mb={3}>
                  {' '}
                  <FormControlLabel
                    value="1"
                    classes={{ root: classes.label }}
                    control={<Radio className={classes.radio} />}
                    label={
                      <Box display="flex" flexWrap="wrap">
                        <img className={classes.img} src={Visa} />
                        <img className={classes.img} src={Orange} />
                        <img className={classes.img} src={Express} />
                        <img className={classes.img} src={Jcb} />
                        <img
                          className={classes.img}
                          src={Wechat}
                          style={{ marginTop: isMobile ? '6px' : '' }}
                        />
                      </Box>
                    }
                  />
                  <Typography component="div">
                    <Box fontSize="body1.fontSize" ml={isMobile ? 0 : 5} my={1} fontWeight="600">
                      {t('common.credit_or_other')}
                      {/* • {t('payMents.stripe_paragraphs.0')} */}
                    </Box>
                    <Box
                      fontSize={isMobile ? 'body2.fontSize' : 'body1.fontSize'}
                      ml={isMobile ? 0 : 5}
                      my={1}
                      color="grey.300"
                    >
                      *{t('payMents.stripe_paragraphs.1')}
                    </Box>
                  </Typography>
                </InfoWrapper>
                {/* <InfoWrapper className={classes.box}>
              <FormControlLabel
                classes={{ root: classes.label }}
                value="0"
                control={<Radio />}
                label={
                  <Box>
                    <img className={classes.img} src={Atome} alt="atome img" />
                    <Box
                      borderRadius="4px"
                      bgcolor="#F3F4F6"
                      display="flex"
                      padding={1}
                      fontSize={isMobile ? '9px' : 'body1.fontSize'}
                      height={32}
                      alignItems="center"
                    >
                      {t('payMents.atome_paragraphs.0')}
                    </Box>
                  </Box>
                }
              />
              <Typography component="div">
                {paymentInfo?.promotion ? (
                  <Box
                    fontSize={isMobile ? 'body2.fontSize' : 'body1.fontSize'}
                    color="grey.300"
                    ml={isMobile ? 0 : 5}
                    mt={1}
                  >
                    {t('payMents.atome_paragraphs.1', {
                      currency: paymentInfo?.currency,
                      originPrice: paymentInfo?.originPrice,
                      promotion: paymentInfo?.promotion,
                      payPrice: paymentInfo?.payPrice,
                    })}
                  </Box>
                ) : (
                  <Box
                    fontSize={isMobile ? 'body2.fontSize' : 'body1.fontSize'}
                    color="secondary.main"
                    ml={isMobile ? 0 : 5}
                    mt={1}
                    fontWeight="fontWeightBold"
                  >
                    {t('payMents.atome_paragraphs.3')}
                  </Box>
                )}
              </Typography>
            </InfoWrapper> */}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box mx={isMobile ? 1 : 5} mt={2} display="flex" justifyContent="flex-end">
            <Button
              fullWidth={isMobile}
              type="submit"
              variant="contained"
              color="secondary"
              style={{ width: !isMobile && 180, height: !isMobile && 60, fontSize: !isMobile && '18px' }}
              onClick={handleChangeRadio}
              disabled={payAtomeStatus === 'pending' || payStatus === 'pending' || !value}
            >
              {payAtomeStatus === 'pending' || payStatus === 'pending' ? (
                <CircularProgress color="inherit" size={24} />
              ) : (
                t('common.go_on')
              )}
            </Button>
          </Box>
        </Box>
        {!isMobile && (
          <Box ml={3} width="35%">
            {productAbstract()}
          </Box>
        )}
      </Box>

      {isMobile ? (
        <EDrawer
          open={tutorialDialog}
          onClose={handleReminderDialogCancelSubmit}
          title={t('glossary. use_discount_code')}
          className={classes.paymentTutorial}
        >
          <PaymentTutorial noTitle />
          <FixedButtonWrapper>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="secondary"
              onClick={onSubmit}
              disabled={payAtomeStatus === 'pending' || payStatus === 'pending'}
            >
              {t('common.go_on')}
            </Button>
          </FixedButtonWrapper>
        </EDrawer>
      ) : (
        <Dialog open={tutorialDialog}>
          <Box mb={2}>
            <Box py={2.5} fontSize={20} fontWeight={600} textAlign="center">
              {t('glossary. use_discount_code')}
            </Box>
            <IconButton
              aria-label="close"
              className={classes.button}
              onClick={() => setTutorialDialog(false)}
            >
              <CloseIcon />
            </IconButton>
            <Divider className={classes.dividerStyle} />
          </Box>
          <DialogContent>
            <PaymentTutorial noTitle />
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button
              // fullWidth
              className={classes.continue}
              type="submit"
              variant="contained"
              color="secondary"
              onClick={onSubmit}
              disabled={payAtomeStatus === 'pending' || payStatus === 'pending'}
            >
              {t('common.go_on')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  )
}

export default Paying
